import { TableCell, withStyles, createStyles } from '@material-ui/core';

export const SHeadTableCell = withStyles(() =>
  createStyles({
    head: {
      fontWeight: 700,
    },
  })
)(TableCell);
